module.exports = __webpack_public_path__ + "static/media/button_cert_english.a06ba77b.png";